var global = require('../internals/global');

module.exports = global.Promise;



// WEBPACK FOOTER //
// ../node_modules/core-js-pure/internals/native-promise-constructor.js